import React from 'react';
import 'antd/dist/antd.css'; 
import '../App.css';
import { ClockCircleTwoTone } from '@ant-design/icons';
import axios from 'axios';
import {Helmet} from "react-helmet";
// const Buentrabajo = () => {
    export default class Error extends React.Component {
        state = {
            parrafos:{}
        }
        
        componentDidMount() {
            const baseUrl = "https://a3l.com.ar/Cotizador/Backend/DatosPagina/PAGINA_PENDIENTE";
            axios.get(baseUrl)
            .then(res => {
                const parrafos = res.data;
                this.setState({ parrafos });
            })
        }
        
        render() {      
    return (

        <div className="containerPrincipal">
            <div className="containerSecundario">
                <ClockCircleTwoTone twoToneColor="#ffc107" style={{fontSize:"70px"}} /> <br/><br/>
                <h1 className='bold'> { this.state.parrafos.parrafo1}</h1><br/>
                <h2 className='lighter'> { this.state.parrafos.parrafo2}</h2><br/>
                <br/><h2 className='lighter'>{ this.state.parrafos.parrafo3}</h2><br/><br/><br/>
            </div>
            <Helmet>
              <script src="iframeResizer.contentWindow.min.js" type="text/javascript" />
            </Helmet>      
        </div>

    )
        }
}

// export default Buentrabajo



